// extracted by mini-css-extract-plugin
export default {"inputGroup":"base_inputGroup__X6k0D","inputGroupOpen":"base_inputGroupOpen__EiPwY"};